import { QuestionFlow } from "../components/QuestionFlow";

const QUESTIONS = [
  {
    key: "q4_tried",
    question: "What have you already tried to feel better or more centred?",
    micro: "It's completely okay, wherever you're starting from.",
    options: [
      "Therapy or counselling.",
      "Meditation or mindfulness apps.",
      "Self-help books or courses.",
      "Spiritual practices — yoga, energy work, etc.",
      "I haven't tried much yet.",
    ],
  },
  {
    key: "q5_longing",
    question: "What are you most longing for right now?",
    micro: "Your longing for peace and clarity is deeply valid.",
    options: [
      "Inner peace and calm.",
      "Emotional healing and self-acceptance.",
      "Clarity about my life direction.",
      "Deeper spiritual connection.",
      "A safe space to talk and be heard.",
    ],
  },
  {
    key: "q6_readiness",
    question: "How ready do you feel to receive support?",
    micro: "It's completely okay to feel nervous about support.",
    options: [
      "I'm very ready — I've been waiting for something like this.",
      "I'm open, but a bit nervous.",
      "I'm curious and just exploring.",
      "I'm not sure yet.",
    ],
  },
];

export default function SegmentationPage() {
  return <QuestionFlow questions={QUESTIONS} stepNumber={3} nextRoute="/offer" pageTestId="segmentation-page" />;
}
